
import { db } from './firebaseConfig';
import { collection, addDoc } from "firebase/firestore";

const AgregarTipoDb = async ({ tipo, activo, familia, userAdd, userMod, fechaAdd, fechaMod, emp_id }) => {

    return await addDoc(collection(db, 'tipos'), {
        tipo: tipo,
        activo: activo,
        familia: familia,
        useradd: userAdd,
        usermod: userMod,
        fechaadd: fechaAdd,
        fechamod: fechaMod,
        emp_id: emp_id
    })
}

export default AgregarTipoDb;